<div style="height: 94%;width: 100%;overflow: auto;">
    <div>
        <form [formGroup]="createRatingForm" (ngSubmit)="onViewClick()" style="align-items: center;">
            <div class="row" style="padding: 2px;">
                <div class="col-md-4 col-sm-6 col-6" style="padding: 0px 3px ;">
                    <mat-card class="contain_card">
                        <mat-form-field>
                            <input style="cursor: pointer;" matInput [matDatepicker]="stickerView" placeholder="From Date" (click)="stickerView.open()" [max]="currDate" formControlName="fromDate" readonly required>
                            <mat-datepicker-toggle matSuffix [for]="stickerView"></mat-datepicker-toggle>
                            <mat-datepicker #stickerView disabled="false"></mat-datepicker>
                        </mat-form-field>
                    </mat-card>
                </div>

                <div class="col-md-4 col-sm-6 col-6" style="padding: 0px 3px ;">
                    <mat-card class="contain_card">
                        <mat-form-field>
                            <input style="cursor: pointer;" matInput [matDatepicker]="rickerView" placeholder="To Date" (click)="rickerView.open()" [min]="createRatingForm.controls['fromDate'].value" [max]="currDate" formControlName="toDate" readonly required>
                            <mat-datepicker-toggle matSuffix [for]="rickerView"></mat-datepicker-toggle>
                            <mat-datepicker #rickerView disabled="false"></mat-datepicker>
                        </mat-form-field>
                    </mat-card>
                </div>

                <div class="col-md-4 col-sm-12 col-12" style="padding: 0px ;">
                    <button type="submit" id="btnnInsidePage">
                        VIEW<mat-icon class="icon-style">search</mat-icon>
                    </button>
                </div>

            </div>
        </form>
    </div>
    <div id="table_shipping_report">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="width: max-content !important; min-width: 100%;">
            <caption></caption>

            <!-- <ng-container matColumnDef="date">
                <th scope="col" mat-header-cell *matHeaderCellDef> Date </th>
                <td mat-cell *matCellDef="let element" id="text_align">{{element.feedbackDate | date :
                    constant.dateTimeFormatForView}}</td>
            </ng-container>

            <ng-container matColumnDef="ratingby">
                <th scope="col" mat-header-cell *matHeaderCellDef> Rating By </th>
                <td mat-cell *matCellDef="let element" id="text_align">{{element.customerCode}}</td>
            </ng-container>


            <ng-container matColumnDef="transactionNo">
                <th scope="col" mat-header-cell *matHeaderCellDef> Transaction No </th>
                <td mat-cell *matCellDef="let element" id="text_align">{{element.transactionNo}}</td>
            </ng-container>

            <ng-container matColumnDef="ratingsValue">
                <th scope="col" mat-header-cell *matHeaderCellDef> Feedback Value </th>
                <td mat-cell *matCellDef="let element" id="number_align">{{element.toDeliveryBoy}}</td>
            </ng-container> -->

            <ng-container matColumnDef="byCustomer">
                <th scope="col" mat-header-cell *matHeaderCellDef> Customer </th>
                <td mat-cell *matCellDef="let element">
                    <ng-template #t let-fill="fill">
                        <span class="star" [class.full]="fill === 100">
                            <span class="half" [style.width.%]="fill">&#9733;</span>&#9733;
                        </span>
                    </ng-template>
                    <ngb-rating [readonly]="true" [max]=5 [(rate)]="element.avgRatingByCustomer" [starTemplate]="t">
                    </ngb-rating><br><span> Rate: {{element.avgRatingByCustomer}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="byLocation">
                <th scope="col" mat-header-cell *matHeaderCellDef>Location </th>
                <td mat-cell *matCellDef="let element">
                    <ng-template #t let-fill="fill">
                        <span class="star" [class.full]="fill === 100">
                            <span class="half" [style.width.%]="fill">&#9733;</span>&#9733;
                        </span>
                    </ng-template>
                    <ngb-rating [readonly]="true" [max]=5 [(rate)]="element.avgRatingByLocation" [starTemplate]="t">
                    </ngb-rating><br><span> Rate: {{element.avgRatingByLocation}}</span>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns ; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</div>